module.exports = __webpack_public_path__ + "img/hok8.1684ad9b.png";